import { render, staticRenderFns } from "./ADNewAssignmentModal.vue?vue&type=template&id=3debaa3a&"
import script from "./ADNewAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./ADNewAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports